import React, {CSSProperties, ReactNode} from "react";
import AnnotationRectangle from "./AnnotationRectangle";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import {
	Annotation,
	AnnotationPointPoint, BorderStyle, Markup,
	MetadataRectangle
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import EffectStyle from "./EffectStyle";
import {SVG_NAMESPACE} from "../../../../shared/annotation/Annotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";

export class SquareAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let rectBoundaries: MetadataRectangle = this.getRectangleBoundaries();
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");

		let points: Array<AnnotationPointPoint> = [
			AnnotationPointPoint.fromJson({x: 0, y: 0}),
			AnnotationPointPoint.fromJson({x: rectBoundaries.width, y: 0}),
			AnnotationPointPoint.fromJson({x: rectBoundaries.width, y: rectBoundaries.height}),
			AnnotationPointPoint.fromJson({x: 0, y: rectBoundaries.height})
		];

		let borderCloud: boolean = false;
		let annotationStyle: CSSProperties = {
			opacity: FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100,
			stroke: color
		};

		if (FunctionHelper.exists(annotation.border)) {
			annotationStyle.fill = annotation.border!.interiorColor;
			annotationStyle.strokeWidth = annotation.border!.width!.toString();

			if (annotation.border!.style === BorderStyle.Dashed) {
				annotationStyle.strokeDasharray = JSON.parse(annotation.border!.dashPattern!).join(",");
			} else if (annotation.border!.effectStyle === EffectStyle.CLOUD) {
				borderCloud = true;
				annotationStyle.stroke = "none";
			}
		}

		return (
			<AnnotationRectangle {...this.props} {...rectBoundaries}
								 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
								 popupCreator={annotation.markup?.creator} popupColor={color}
								 popupContent={annotation.contents} creationDate={annotation.markup?.creationDate}
								 style={{
									 zIndex: 0
								 }}>
				<svg xmlns={SVG_NAMESPACE}>
					{borderCloud &&
					this.renderCloudBorder(points, annotation.border!.width!, color, annotation.border!.interiorColor!)
					}
					<rect x={0} y={0} width={rectBoundaries.width} height={rectBoundaries.height}
						  style={annotationStyle}/>
				</svg>
			</AnnotationRectangle>
		);
	}
}